import { createContext } from 'react';

interface TenantContextValue {
    theme?: any;
    globalStyles?: any;
}

export const TenantContext = createContext<TenantContextValue>(null as unknown as TenantContextValue);

